import api from '.';
import { InvitedMember, Account } from '@karehero/models';

export const invitedMemberApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllInvitedMember: builder.query<InvitedMember[], void>({
      query: () => '/invite',
      providesTags: ['InvitedMembers'],
    }),
    updateInviteAwaitingFee: builder.mutation<void, InvitedMember>({
      query: (invitedMember) => ({
        url: `/invite/${invitedMember.id}/mark-fee-paid`,
        method: 'POST',
      }),
      invalidatesTags: ['InvitedMembers'],
    }),
    associateKindeAccountWithInvite: builder.mutation<
      Account,
      { inviteID: string; kindeID: string }
    >({
      query: ({ inviteID, kindeID }) => ({
        url: `/invite/${inviteID}/associate-kinde-account`,
        method: 'POST',
        body: { kindeID },
      }),
      invalidatesTags: ['InvitedMembers', 'Accounts'],
    }),
  }),
});

export const {
  useGetAllInvitedMemberQuery,
  useUpdateInviteAwaitingFeeMutation,
  useAssociateKindeAccountWithInviteMutation,
} = invitedMemberApi;

export default invitedMemberApi;
